import DestroyModal from 'components/generics/DestroyModal'
import React from 'react'
import { Button, Card, Icon } from 'semantic-ui-react'
import EditModal from "../forms/EditModal";
import ConsultationTypeForm from "./ConsultationTypeForm";

export default class ConsultationTypesListItem extends React.Component {
  handleDestroy = () => {
    this.props.destroyEntity(this.props.consultationType)
  }

  isProtectedType = (name) => {
    const protectedTypes = ['Consultatie', 'Annulatie', 'No-show'];
    return protectedTypes.includes(name);
  }

  render () {

    const consultationType = this.props.consultationType
    const isProtected = this.isProtectedType(consultationType.name)

    let ConsultationTypeHeader = (props) => {
      return(
        <Card.Content onClick={props.onClick} style={ props.onClick ? { cursor: 'pointer' } : {}}>
            <Card.Header>
              {consultationType.name}
            </Card.Header>
            { consultationType.createdAt ?
              <Card.Meta>
                {I18n.t('components.consultation_type_list_item.since', { date: I18n.l("date.formats.default",consultationType.createdAt) })}
              </Card.Meta> :
              null
            }
        </Card.Content>)
    }

    if( this.props.readonly ){
      return (
        <Card key={consultationType.id}>
          <ConsultationTypeHeader/>
          <Card.Content extra>
            <Icon name={consultationType.icon || 'question'} size='large'/>
          </Card.Content>
        </Card>)
    }

    return (
      <Card key={consultationType.id}>
        {isProtected ? <ConsultationTypeHeader/> :
          <EditModal entityName="consultationType" EntityForm={ConsultationTypeForm}
                    entityId={consultationType.id} trigger={ConsultationTypeHeader}/> }

        <Card.Content extra>
          <Icon name={consultationType.icon || 'question'} size='large'/>
          {isProtected ?
            <Button size='mini' compact floated='right' disabled>
              {I18n.t('components.consultation_type_list_item.protected')}
            </Button> :
            <DestroyModal easy
                          handleDestroy={this.handleDestroy}
                          trigger={(props) => { return(
                            <Button color='red' size='mini' compact floated='right' inverted
                                    onClick={(event) => {event.stopPropagation(); event.preventDefault(); return props.onClick() }}>
                              <Icon name='trash'/> {I18n.t('components.calendar_list.destroy')}
                            </Button>)
                          }}>
              {I18n.t('components.consultation_type_list_item.destroy_warning')}
            </DestroyModal>
          }
        </Card.Content>
    </Card>)
  }
}

